var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBrazilFlag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#009b37",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 336.55914307,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path4679",
    cx: 98.097542,
    cy: 107.28635,
    r: 69.198166
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#f3d603",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 293.16552734,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "rect4681",
    width: 67.405678,
    height: 67.405678,
    x: -74.096138,
    y: 123.50531,
    transform: "matrix(0.83976945,-0.54294316,0.83976945,0.54294316,0,0)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#012775",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 301.61221313,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path4675",
    cx: 98.097542,
    cy: 107.28635,
    rx: 24.097765,
    ry: 24.539925
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrazilFlag);
export default __webpack_public_path__ + "static/media/brazil_flag.92730efae8ed02017fec3924ccf4fcf2.svg";
export { ForwardRef as ReactComponent };